//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.ProjectionOptions.js";
import "../GeometricUtilities/GeometricUtilities.RefitControlBuilder.js";
import "../no/Section.js";
import "../no/SelectTaggedObject.js";
import "../no/SelectFace.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
import "../no/SelectObject.js";
let d=[[[0,"CutType",1,0],[0,"DivideSurface",1,0],[0,"EditCopy",1,0],[1,"IsoparametricPosition",0,"Expression",0],[0,"KeepOppositeSurface",1,0],[0,"ProjectBothSides",1,0],[1,"ProjectDirection",0,"GeometricUtilities.ProjectionOptions",0],[1,"RefitControl",0,"GeometricUtilities.RefitControlBuilder",0],[0,"RegionPickPoint",1,0],[0,"SelectUV",1,0],[1,"SnippingCurve",0,"Section",0],[1,"SnippingObject",0,"SelectTaggedObject",0],[0,"SnippingPlane",1,"Plane",0],[0,"SurfacePointUV",1,0],[1,"TargetFace",0,"SelectFace",0],[0,"Type",1,0]],[[[],"GetCreateNewCopy",{R_:{createNewCopy:''}},0,0],[["createNewCopy"],"SetCreateNewCopy",{},1,0]],[]];
SPLM.Features.SnipSurfaceBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SnipSurfaceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SnipSurfaceBuilder.Types = Object.freeze({
    "SnipCurve" : "SnipCurve", "SnipSurface" : "SnipSurface", "SnipAtPlane" : "SnipAtPlane", "IsoparamSnip" : "IsoparamSnip"});

export default SPLM;